import React from 'react';
import { Switch } from 'react-router-dom';
import { routes as authRoutes } from './authRoutes';
import { routes as appRoutes } from './appRoutes';
import Route, { RouteProps } from './route';

const routes: Array<RouteProps> = [...authRoutes, ...appRoutes];

export default function Router() {
  return (
    <Switch>
      {routes.map(route => (
        <Route key={route.path} {...route} />
      ))}
    </Switch>
  );
}
